import { lazy } from 'react'
import { type RouteObject } from 'react-router-dom'

const PenerimaanFgPage = lazy(() => import('./pages/penerimaan-fg'))
const DetailPenerimaanFgPage = lazy(() => import('./pages/detail-penerimaan-fg'))
const PutawayFgMonitorPage = lazy(() => import('./pages/putaway-fg-monitor'))
const PutawayFgOperatorPage = lazy(() => import('./pages/putaway-fg-operator'))
const TerimaCekFgPage = lazy(() => import('./pages/terima-cek-fg'))

/** Cluster C08 Inbound FG — IFG-01 (penerimaan-fg, :id), IFG-03 (putaway-fg-monitor), IFG-04 (putaway-fg-operator), IFG-05 (terima-cek-fg). */
const inboundFgRoutes: RouteObject[] = [
  {
    path: 'inbound-fg',
    children: [
      {
        path: 'penerimaan-fg',
        children: [
          { index: true, element: <PenerimaanFgPage /> },
          { path: ':id', element: <DetailPenerimaanFgPage /> }
        ]
      },
      { path: 'putaway-fg-monitor', element: <PutawayFgMonitorPage /> },
      { path: 'putaway-fg-operator', element: <PutawayFgOperatorPage /> },
      { path: 'terima-cek-fg', element: <TerimaCekFgPage /> }
    ]
  }
]

export default inboundFgRoutes
